module.exports = __webpack_public_path__ + "static/magento_logo_vertical-ecdbd866ecf3b784b70a71d6797bd5e4.png";